import Confetti from 'react-confetti';
import useWindowSize from 'react-use/lib/useWindowSize';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

const RecoConfetti = (props) => {
  const [isRightConfettiActive, setIsRightConfettiActive] = useState(false);
  const [isLeftConfettiActive, setIsLeftConfettiActive] = useState(false);
  const [everBeenActive, setEverBeenActive] = useState(false);

  const { width: winWidth, height: winHeight } = useWindowSize();
  const leftConfetti = (
    <Confetti
      width={winWidth}
      height={winHeight}
      run={isLeftConfettiActive}
      confettiSource={{ x: 0, y: winHeight, width: 5, height: 5 }}
      initialVelocityY={props.initialVelocityY}
      initialVelocityX={props.initialVelocityX}
      numberOfPieces={props.numberOfPieces}
      recycle={false}
      onConfettiComplete={() => setIsLeftConfettiActive(false)}
    />
  );
  const rightConfetti = (
    <Confetti
      width={winWidth}
      height={winHeight}
      run={isRightConfettiActive}
      confettiSource={{ x: winWidth, y: winHeight, width: 5, height: 5 }}
      initialVelocityY={props.initialVelocityY}
      initialVelocityX={{
        min: -props.initialVelocityX.max,
        max: -props.initialVelocityX.min
      }}
      numberOfPieces={props.numberOfPieces}
      recycle={false}
      onConfettiComplete={() => setIsRightConfettiActive(false)}
    />
  );

  if (props.isActive) {
    if (!everBeenActive) {
      setIsLeftConfettiActive(true);
      setIsRightConfettiActive(true);
      setEverBeenActive(true);
    }
  }

  return (
    <>
      {leftConfetti}
      {rightConfetti}
    </>
  );
};

RecoConfetti.propTypes = {
  isActive: PropTypes.bool,
  numberOfPieces: PropTypes.number,
  initialVelocityX: PropTypes.object,
  initialVelocityY: PropTypes.object
};

RecoConfetti.defaultProps = {
  isActive: false,
  numberOfPieces: 150,
  initialVelocityX: { min: 1, max: 15 },
  initialVelocityY: { min: -20, max: 0 }
};

export default RecoConfetti;
